import PASSIVE_SUPPORT from 'constants/passive-events';
import { scrollTo } from 'utils';

import { ScrollHandler } from './index';

class NativeScroll implements ScrollHandler {
  private element!: HTMLElement;
  private _callback: null | (() => void) = null;

  public init(element: HTMLElement) {
    this.element = element;

    (this.element.style as any).WebkitOverflowScrolling = 'touch';
    this.element.style.overflowY = 'scroll';
    this.element.style.overflowX = 'hidden';
    this.element.style.transform = 'translateZ(0)';

    return Promise.resolve();
  }
  public reinitialize() {
    return Promise.resolve();
  }

  public enable() {
    this.element.style.overflow = 'scroll';
  }
  public disable() {
    this.element.style.overflow = 'hidden';
  }

  public onScroll(callback: (data: { y: number }) => void) {
    this._callback = () => callback({
      y: this.element.scrollTop,
    });
    this.element.addEventListener('scroll', this._callback, PASSIVE_SUPPORT);
  }
  public offScroll() {
    if (!this._callback) return;
    this.element.removeEventListener('scroll', this._callback);
    this._callback = null;
  }

  public scrollTo(offset: number, duration = 350) {
    scrollTo(this.element, offset, duration);
  }

  get type() {
    return 'native';
  }
  get y() {
    return this.element.scrollTop;
  }

  public onResize() {
    if (typeof this._callback !== 'function') return;

    this._callback();
  }
  /* eslint-disable @typescript-eslint/no-empty-function */
  // tslint:disable-next-line no-empty
  public refresh() {
  }
}

export default NativeScroll;
